import React from "react";
import { Link } from "react-router-dom";


interface IProps
{
	data: IBreadCrumbData[]
}

export interface IBreadCrumbData
{
	label: string,
	path?: string
}

function BreadCrumbs(props: IProps)
{
	// const history = useHistory();
	
	// function onClick(href: string | undefined)
	// {
	// 	if (href) {
	// 		history.push(href);
	// 	}
	// }

	return (
			<div className="ant-breadcrumb"> 
			{
				props.data.map((item, index) =>
				{
					// The last item
					if (index === props.data.length - 1) {
						return (
							<span key={index}>
								<span className="ant-breadcrumb-link">{item.label}</span>
							</span>
						);
					}

					// Default item
					return (
						<span key={index}>
							
								<Link to={item.path as string}><span className="ant-breadcrumb-first">{item.label}</span></Link>
							
							<span className="ant-breadcrumb-separator">/</span>
						</span>
					)
				})
			}
			</div> 
	);
};

export default BreadCrumbs;